import { servicesUsers } from 'services';
import { users as typesUsers, network } from 'types';
import useQueryHookWrapper from 'hooks/use-query-hook-wrapper';
import { QueryConfig } from 'react-query';

const useUsersDetail = (
    id: string,
    arg0?: QueryConfig<
        network.TQueryDefWrapper<typesUsers.TUsersDetail>,
        string
    >,
) => {
    return useQueryHookWrapper<
        network.TQueryDefWrapper<typesUsers.TUsersDetail>,
        string,
        string
    >({
        queryKey: `users-detail`,
        queryFn: servicesUsers.getById,
        queryConfig: arg0,
        values: id,
    });
};

export default useUsersDetail;
